module.exports = {
	"subscribe": {
		"titles": {
			"address": "Endereço",
			"basic_information": "Informações básicas",
			"payment_method": "Forma de pagamento",
			"payment_review": "Resumo e pagamento",
			"identify": "Identifique-se",
			"payment": "Pagamento"
		},
		"attributes": {
			"register_as_legal_entity": "Fazer meu cadastro como Pessoa Jurídica.",
			"choose_another_plan": "Escolher outro plano",
			"choose_your_plan": "Escolha seu plano",
			"after_the_contract_see": "Após a contratação você visualizará o boleto bancário que será enviado mensalmente a você via e-mail após a confirmação do primeiro pagamento.",
			"change_my_data": "Alterar meus dados",
			"enter_your_data": "Insira seus dados",
			"subscriber_information": "Dados do assinante",
			"plan_contracted_successfully": "Plano contratado com sucesso",
			"barcode": "Código de barras",
			"monthly": "por mês",
			"plans": "planos",
			"plan_not_found": "Não há planos cadastrados!",
			"suggested": "Recomendado",
			"billet": "Boleto bancário",
			"email": "E-mail",
			"choose_another_email": "Escolher outro e-mail",
			"cpf": "CPF",
			"cpf_in_use": "O CPF já está em uso",
			"trade_name": "Nome fantasia",
			"company_name": "Razão social",
			"cnpj": "CNPJ",
			"post_code": "CEP",
			"street": "Rua/Av",
			"address": "Endereço",
			"number": "Número",
			"neighborhood": "Bairro",
			"complement": "Complemento",
			"city": "Cidade",
			"state": "Estado",
			"password": "Senha",
			"full_name": "Nome completo",
			"name": "Nome",
			"phone": "Telefone",
			"forgot_postal_code": "Não sei meu CEP",
			"forgot_password": "Esqueci minha senha",
			"subscribe_review": "Resumo da assinatura",
			"chosen_plan": "Plano escolhido",
			"almost_there_just_have_pay": "Está quase lá, agora só falta realizar o pagamento..."
		},
		"labels": {
			"signature_code": "Código de sua assinatura",
			"payment_method": "Forma de pagamento",
			"barcode": "Código de barras"
		},
		"buttons": {
			"redirect_to_bank": "Abrir ambiente do banco",
			"confirm_hiring": "Confirmar contratação",
			"view_billet": "Ver boleto",
			"code_copied": "Código de barras copiado!",
			"copy_barcode_numbers": "Copiar código de barras",
			"hire": "Contratar",
			"load_more_planes": "Carregar mais planos",
			"choose_plan": "Escolher plano",
			"change_email": "Trocar de e-mail",
			"choose_another_plan": "Escolher outro plano",
			"open_transfer": "Transferir"
		},
		"placeholder": {
			"email": "Digite seu e-mail",
			"fill_full_name": "Nome completo",
			"only_numbers": "Telefone"
		},
		"error": {
			"required_field": "Campo necessário",
			"invalid_cpf": "CPF inválido",
			"invalid_cnpj": "CNPJ inválido",
			"invalid_postal_code": "CEP inválido!"
		},
		"messages": {
			"almost_there": "Quase lá, agora é só efetuar o pagamento!",
			"print_or_copy_to_pay": "O Boleto não será enviado pelos Correios, realize a impressão ou <strong class=\"ls-color-theme\">copie o código de barras para pagar pela internet.</strong>",
			"payment_confirmation_automatically": "A <strong class=\"ls-color-theme\">confirmação do pagamento será realizada de forma automática</strong> no prazo de até <strong class=\"ls-color-theme\">3 dias úteis</strong> após a realização do pagamento.",
			"payment_confirmation_automatically_transfer": "A <strong class=\"ls-color-theme\">confirmação do pagamento será realizada de forma automática</strong> no prazo de até <strong class=\"ls-color-theme\">2 horas</strong> após a realização do pagamento.",
			"signature_will_only_be_approved_after_payment_confirmation": "Sua assinatura somente será ativada após a <strong class=\"ls-color-theme\">aprovação do pagamento</strong>, caso não seja identificado, sua assinatura será cancelada.",
			"warning": "Atenção:",
			"can_not_complete_until_the_payment_method_settings": "Não será possível realizar a contratação até a configuração da forma de pagamento.",
			"return_later": "Aguarde e volte em breve!",
			"show_all_plans": "Mostrar todos planos",
			"showing_total": "Mostrando total de",
			"ticket_will_be_shown_when_you_confirm_a_subscribe_and_will_be_sent_to_your_email_after_first_confirmation": "O boleto será apresentado ao confirmar a assinatura. Após a confirmação do primeiro pagamento o boleto de cobrança mensal será enviado ao e-mail cadastrado.",
			"data_loaded_successfully": "Seus dados foram carregados da sua conta!",
			"before_next_step": "É necessário finalizar todas as etapas antes de contratar o plano selecionado!",
			"successful_email": "E-mail encontrado em nosso sistema. Faça o login!",
			"new_email": "E-mail disponível em nosso sistema. Complete seu cadastro!",
			"transfer_instructions": "Ao clicar no botão <strong class=\"ls-color-theme\">Abrir ambiente do banco</strong>, você será direcionado para o banco escolhido.",
			"loading": {
				"postal_code": "Carregando endereço"
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./~/yaml-loader!./src/lang/subscribe/pt-BR.yml
// module id = 594
// module chunks = 1